import { getCookie } from '../getCookie/getCookie.js';
import { PULSE_COOKIE_NAME } from './constants.js';
import parseCookieValue from './parse.js';

/**
 * Retrieves the Environment ID from the Pulse cookie in the browser.
 *
 * Attempts to read the Pulse cookie (as defined by `PULSE_COOKIE_NAME`) from the browser's cookies,
 * then parses its value to extract the Environment ID.
 *
 * @returns The extracted Environment ID as a string, or `null` if the cookie is not found or cannot be parsed.
 *
 * @example
 * ```ts
 * const envId = getEnvironmentIdFromCookie();
 * if (envId) {
 *   // Use the environment ID
 * }
 * ```
 */
const getEnvironmentIdFromCookie = () => {
    try {
        const pulseCookie = getCookie(PULSE_COOKIE_NAME);
        if (pulseCookie != undefined) {
            const id = parseCookieValue(pulseCookie);
            return id;
        }
        else {
            console.error('The Pulse cookie could not be read to extract the EnvironmentID.');
            return null;
        }
    }
    catch (e) {
        console.error('Error while parsing the Cookie to get the Environment ID:', e.message);
        return null;
    }
};

export { getEnvironmentIdFromCookie as default };
//# sourceMappingURL=from-cookie.js.map
